export default "__VITE_ASSET__CvNlF4Cs__"